import {useState} from "react";
import "./App.css";
import Menu from "./components/menu/Menu";
import Sidebar from "./components/sidebar/Sidebar";
import Coaches from "./components/main/Coaches";
import Players from "./components/main/Players";
import MissingEmailPlayers from "./components/main/MissingEmailPlayers";
import CoachView from "./components/main/CoachView";
import Transaction from "./components/main/Transaction";
import Shopify from "./components/main/Shopify";
import Locations from "./components/main/Locations";
import LocationSearch from "./components/main/LocationSearch";
import Questions from "./components/main/Questions";
import UserAnswers from "./components/main/UserAnswers.js";
import CoachPlayers from "./components/main/CoachPlayers";
import Dashboard from "./components/main/Dashboard";
import Login from "./components/auth/Login";
import Filters from "./components/main/Filters.js";
import ExternalLessons from "./components/main/ExternalLessons.js";
import ExternalLessonClicks from "./components/main/ExternalLessonClicks.js";
import Messages from "./components/main/Messages.js";
import PlayerLocationSearch from "./components/main/PlayerLocationSearch.js";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {isAuthenticated} from "./components/apicalls/auth";
import CoachSchedulesAdmin from "./components/main/CoachSchedulesAdmin";
import Lessons from "./components/main/Lessons";
import UpcomingLessons from "./components/main/UpcomingLessons";
import CreditLedger from "./components/main/CreditLedger";
import PackagePurchases from "./components/main/PackagePurchases";
import CreditsDashboard from "./components/main/CreditsDashboard";
import MatchResults from "./components/main/MatchResults";
import MatchNeeds from "./components/main/MatchNeeds";
import Leagues from "./components/main/Leagues";
import RestringingVendors from "./components/main/RestringingVendors";
import CoachCommissions from "./components/main/CoachCommissions";
import CoachMatchRequests from "./components/main/CoachMatchRequests";
import { AdminDemos } from "./components/main/AdminDemos";
import { AdminDemoAssets } from "./components/main/AdminDemoAssets";
import { AdminDemoPolicies } from "./components/main/AdminDemoPolicies";
import MarketingSegments from "./components/main/MarketingSegments";

const App = () => {
  const [sidebarOpen, setsidebarOpen] = useState(false);
  const openSidebar = () => {
    setsidebarOpen(true);
  };
  const closeSidebar = () => {
    setsidebarOpen(false);
  };

  const PrivateRoute = ({children}) => {
    const user = isAuthenticated();
    return user ? children : <Navigate to="/login" />;
  };
  return (
    <div className="app_container">
      <BrowserRouter>
        <Menu sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
        <Routes>
          <Route
            path="/"
            exact
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/players"
            exact
            element={
              <PrivateRoute>
                <Players />
              </PrivateRoute>
            }
          />
          <Route
            path="/players/missing-email"
            exact
            element={
              <PrivateRoute>
                <MissingEmailPlayers />
              </PrivateRoute>
            }
          />
          <Route
            path="/transaction"
            exact
            element={
              <PrivateRoute>
                <Transaction />
              </PrivateRoute>
            }
          />
          <Route
            path="/shopify"
            exact
            element={
              <PrivateRoute>
                <Shopify />
              </PrivateRoute>
            }
          />
          <Route
            path="/locations"
            exact
            element={
              <PrivateRoute>
                <Locations />
              </PrivateRoute>
            }
          />
          <Route
            path="/locations_search"
            exact
            element={
              <PrivateRoute>
                <LocationSearch />
              </PrivateRoute>
            }
          />
          <Route
  path="/player_locations"
  exact
  element={
    <PrivateRoute>
      <PlayerLocationSearch />
    </PrivateRoute>
  }
/>
          <Route
            path="/messages"
            exact
            element={
              <PrivateRoute>
                <Messages />
              </PrivateRoute>
            }
          />     
          <Route
            path="/filters"
            exact
            element={
              <PrivateRoute>
                <Filters />
              </PrivateRoute>
            }
          />
          <Route
            path="/external_lessons"
            exact
            element={
              <PrivateRoute>
                <ExternalLessons />
              </PrivateRoute>
            }
          />
          <Route
            path="/external_lesson_clicks"
            exact
            element={
              <PrivateRoute>
                <ExternalLessonClicks />
              </PrivateRoute>
            }
          />
          <Route
            path="/question"
            exact
            element={
              <PrivateRoute>
                <Questions />
              </PrivateRoute>
            }
          />
          <Route
            path="/survey_user_answers"
            exact
            element={
              <PrivateRoute>
                <UserAnswers />
              </PrivateRoute>
            }
          />
          <Route
            path="/coachplayers/:id"
            exact
            element={
              <PrivateRoute>
                <CoachPlayers />
              </PrivateRoute>
            }
          />
          <Route
            path="/view/:id"
            exact
            element={
              <PrivateRoute>
                <CoachView />
              </PrivateRoute>
            }
          />
          <Route
            path="/Coaches"
            exact
            element={
              <PrivateRoute>
                <Coaches />
              </PrivateRoute>
            }
          />
          <Route
            path="/coach-schedules"
            element={
              <PrivateRoute>
                <CoachSchedulesAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/lessons"
            element={
              <PrivateRoute>
                <Lessons />
              </PrivateRoute>
            }
          />
          <Route
            path="/upcoming-lessons"
            element={
              <PrivateRoute>
                <UpcomingLessons />
              </PrivateRoute>
            }
          />
          <Route
            path="/credit-ledger"
            element={
              <PrivateRoute>
                <CreditLedger />
              </PrivateRoute>
            }
          />
          <Route
            path="/package-purchases"
            element={
              <PrivateRoute>
                <PackagePurchases />
              </PrivateRoute>
            }
          />
         
          <Route
            path="/credits-dashboard"
            element={
              <PrivateRoute>
                <CreditsDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/match-results"
            element={
              <PrivateRoute>
                <MatchResults />
              </PrivateRoute>
            }
          />
          <Route
            path="/match-needs"
            element={
              <PrivateRoute>
                <MatchNeeds />
              </PrivateRoute>
            }
          />
          <Route
            path="/leagues"
            element={
              <PrivateRoute>
                <Leagues />
              </PrivateRoute>
            }
          />
          <Route
            path="/restringing-vendors"
            element={
              <PrivateRoute>
                <RestringingVendors />
              </PrivateRoute>
            }
          />
          <Route
            path="/coach-commissions"
            element={
              <PrivateRoute>
                <CoachCommissions />
              </PrivateRoute>
            }
          />
          <Route path="/coach-match-requests" element={<PrivateRoute><CoachMatchRequests /></PrivateRoute>} />
          <Route path="/admin/demos" element={<PrivateRoute><AdminDemos /></PrivateRoute>} />
          <Route path="/admin/demo-assets" element={<PrivateRoute><AdminDemoAssets /></PrivateRoute>} />
          <Route path="/admin/demo-policies" element={<PrivateRoute><AdminDemoPolicies /></PrivateRoute>} />
          <Route path="/marketing-segments" element={<PrivateRoute><MarketingSegments /></PrivateRoute>} />
          <Route path="/login" exact element={<Login />} />
        </Routes>
        <Sidebar sidebarOpen={sidebarOpen} closeSidebar={closeSidebar} />
      </BrowserRouter>
    </div>
  );
};

export default App;
